import { render, staticRenderFns } from "./BaseSpecials.vue?vue&type=template&id=001d87f0&scoped=true&"
import script from "./BaseSpecials.vue?vue&type=script&lang=js&"
export * from "./BaseSpecials.vue?vue&type=script&lang=js&"
import style0 from "./BaseSpecials.vue?vue&type=style&index=0&id=001d87f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001d87f0",
  null
  
)

export default component.exports